// extracted by mini-css-extract-plugin
module.exports = {"wrap":"rectangular-shadow-wrap_wrap__2OtVF"};